import { render, staticRenderFns } from "./companydetail.vue?vue&type=template&id=fe322cd8&scoped=true&"
import script from "./companydetail.vue?vue&type=script&lang=js&"
export * from "./companydetail.vue?vue&type=script&lang=js&"
import style1 from "./companydetail.vue?vue&type=style&index=1&id=fe322cd8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fe322cd8",
  null
  
)

export default component.exports